import { FunctionComponent, SVGProps } from 'react';
import { cpfFormat } from 'utils/format';
import { IBankAccount } from '../../interfaces';
import { Container } from './_confirmWithdrawAccount';

interface IConfirmWithdrawAccount {
  value: string;
  icon: FunctionComponent<SVGProps<SVGSVGElement>>;
  title: string;
  bankAccountData?: IBankAccount;
  wasSuccessful?: boolean;
  hasError?: boolean;
}

export const ConfirmWithdrawAccount = ({
  bankAccountData,
  hasError,
  value,
  wasSuccessful,
}: IConfirmWithdrawAccount) => {
  const newValue: string = (parseFloat(value) - 3.67).toFixed(2).toString();

  return (
    <Container>
      {wasSuccessful ? (
        <h2 className="confirm-withdraw-account__subtitle">
          Você fez um saque de{' '}
          {new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL',
          }).format(Number(value))}{' '}
          para:
        </h2>
      ) : (
        <h2 className="confirm-withdraw-account__subtitle">
          Confira os dados para saque no valor de{' '}
          {new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL',
          }).format(Number(newValue))}:
        </h2>
      )}

      <div className="confirm-withdraw-account__account-container">
        <p className="confirm-withdraw-account__account-row">
          <b className="confirm-withdraw-account__account-b">NOME: </b>
          <span>{bankAccountData?.legal_name}</span>
        </p>

        <p className="confirm-withdraw-account__account-row">
          <b className="confirm-withdraw-account__account-b">CPF: </b>
          <span>{cpfFormat(bankAccountData?.document_number || '')}</span>
        </p>

        <p className="confirm-withdraw-account__account-row">
          <b className="confirm-withdraw-account__account-b">BANCO: </b>
          <span>
            {bankAccountData?.bank_code?.code} -{' '}
            {bankAccountData?.bank_code?.name}
          </span>
        </p>

        <p className="confirm-withdraw-account__account-row">
          <b className="confirm-withdraw-account__account-b">AGÊNCIA: </b>
          <span>{bankAccountData?.agency}</span>
        </p>

        <p className="confirm-withdraw-account__account-row">
          <b className="confirm-withdraw-account__account-b">CONTA: </b>
          <span>
            {bankAccountData?.account}-{bankAccountData?.account_check_digit}
          </span>
        </p>

        <p className="confirm-withdraw-account__account-row">
          <span>{bankAccountData?.bank_account_type.name}</span>
        </p>
      </div>

      <p className="confirm-withdraw-account__fee-msg">
        Lembre-se, o valor da taxa bancária é de{' '}
        {new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        }).format(3.67)}{'. '}
        O Valor solicitado para saque é de:
        {' '}{new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        }).format(Number(value))}{', '}
        descontando a taxa, o valor que será depositado:
        {' '}{new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        }).format(Number(newValue))}
      </p>
    </Container>
  );
};